import classNames from 'clsx';
import styles from '../../embed.style';
import type { EmbedADT, EmbedProps } from '../../type';

export function replit(input: EmbedADT) {
  // 已经被上游处理过就直接原样输出
  if (!(input instanceof URL)) return input;
  const host = input.host;
  if (host !== 'replit.com') return input;

  // https://replit.com/@Reamd7/rustlings-cn?v=1
  // https://replit.com/@Reamd7/rustlings-cn
  // https://replit.com/@Reamd7/rustlings-cn?embed=true&lite=true

  input.searchParams.set(`embed`, `true`);
  input.searchParams.set(`lite`, `true`);
  input.searchParams.delete(`v`);

  const href = input.href;

  return (props: EmbedProps) => {
    const { width = '', height = '' } = props;

    const children = (
      <div className={classNames('w-full h-full', styles.iframeEmbed)}>
        <iframe
          className={styles.iframe}
          src={href}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
      </div>
    );
    return (
      <div
        className={'w-full'}
        style={
          {
            width: width || undefined,
            '--app-markdown-video-ratio': height ? height : '320px',
          } as any
        }
        data-first={props['data-first']}
        data-last={props['data-last']}
      >
        {children}
      </div>
    );
  };
}
